// import React, { useState, useEffect } from 'react';
// import styled from 'styled-components';

// const MerchantRefaral = () => {
//   const [phoneNumber, setPhoneNumber] = useState('');
//   const [user, setUser] = useState(null);
//   const [data, setData] = useState('');

//   // Load referral code data from localStorage
//   useEffect(() => {
//     const googleLogin = localStorage.getItem('googleLogin');
//     if (googleLogin == "false") {
//       try {
//         const userData = localStorage.getItem('userLogin') || localStorage.getItem('merchantLogin');
//         if (userData) {
//           const parsed = JSON.parse(userData);
//           setData(parsed);
//         }
//       } catch (error) {
//         console.error('Error reading login info:', error);
//       }
//     } else {
//       try {
//         const userData = localStorage.getItem('userLogin') || localStorage.getItem('merchantDashboardLogin');
//         if (userData) {
//           const parsed = JSON.parse(userData);
//           setData(parsed);
//         }
//       } catch (error) {
//         console.error('Error reading login info:', error);
//       }
//     }
//   }, []);

//   // Set user state from localStorage (userLogin or merchantLogin)
//   useEffect(() => {
//     const googleLogin = localStorage.getItem('googleLogin');
//     if (googleLogin == "false") {
//       try {
//         let userData = localStorage.getItem('userLogin');
//         if (!userData) {
//           userData = localStorage.getItem('merchantLogin');
//         }
//         if (userData) {
//           setUser(JSON.parse(userData));
//         }
//       } catch (error) {
//         console.error('Error reading login info:', error);
//       }
//     }else{
//       try {
//         let userData = localStorage.getItem('userLogin');
//         if (!userData) {
//           userData = localStorage.getItem('merchantDashboardLogin');
//         }
//         if (userData) {
//           setUser(JSON.parse(userData));
//         }
//       } catch (error) {
//         console.error('Error reading login info:', error);
//       }
//     }
//   }, []);

//   const handleRefer = () => {
//     const trimmed = phoneNumber.trim();

//     // Validate Indian mobile number
//     if (!/^[6-9]\d{9}$/.test(trimmed)) {
//       alert('Please enter a valid 10-digit Indian mobile number.');
//       return;
//     }

//     if (!user) {
//       alert('User data not loaded yet. Please try again.');
//       return;
//     }

//     const fullNumber = `91${trimmed}`;
//     const message = encodeURIComponent(
//       `Hey! Check out this amazing platform https://bakpoket.com/${data.referralCode}. Join using my referral!`
//     );
//     const whatsappURL = `https://wa.me/${fullNumber}?text=${message}`;

//     window.open(whatsappURL, '_blank');
//   };

//   console.log('Referral Code:', data.referralCode);

//   return (
//     <Container>
//       <InnerBox>
//         <h5>Refer a Friend via WhatsApp</h5>
//         <Input
//           type="tel"
//           placeholder="Enter 10-digit mobile number"
//           value={phoneNumber}
//           onChange={(e) => setPhoneNumber(e.target.value)}
//         />
//         <Button onClick={handleRefer} disabled={!user}>
//           {user ? 'Send Referral' : 'Loading...'}
//         </Button>
//       </InnerBox>
//     </Container>
//   );
// };

// export default MerchantRefaral;

// // Styled Components
// const Container = styled.div`
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   // min-height: 30vh;
//   text-align: center;
//   padding: 20px;
// `;

// const InnerBox = styled.div`
//   width: 100%;
//   max-width: 400px;
// `;

// const Input = styled.input`
//   width: 100%;
//   padding: 12px;
//   font-size: 16px;
//   margin: 12px 0;
//   border: 1px solid #ccc;
//   border-radius: 8px;
//   @media(max-width:576px){
//     padding: 7px;
//     font-size: 11px;
//     margin: 6px 0;
//   }
// `;

// const Button = styled.button`
//   width: 100%;
//   padding: 12px 20px;
//   font-size: 16px;
//   background-color: #25d366;
//   color: white;
//   border: none;
//   border-radius: 8px;
//   cursor: pointer;

//   &:hover {
//     background-color: #1ebd5a;
//   }

//   &:disabled {
//     background-color: #a6a6a6;
//     cursor: not-allowed;
//   }

//   @media(max-width:576px){
//     padding: 7px 10px;
//     font-size: 10px;
//   }
// `;


import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const Refaral = () => {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [user, setUser] = useState(null);
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);

  // Load user and referral data
  useEffect(() => {
    try {
      const googleLogin = localStorage.getItem('googleLogin');
      const isGoogle = googleLogin !== 'false';

      // For merchants, check both dashboard and normal login keys
      const userData =
        // localStorage.getItem(isGoogle ? 'merchantDashboardLogin' : 'merchantLogin') ||
        localStorage.getItem(isGoogle ? 'userDashboardLogin' : 'userLogin');

      if (userData) {
        const parsed = JSON.parse(userData);
        setUser(parsed);
        setData(parsed);
      }
    } catch (error) {
      console.error('Error reading login info:', error);
    } finally {
      setLoading(false);
    }
  }, []);

  const handleRefer = () => {
    const trimmed = phoneNumber.trim();

    // Validate Indian mobile number
    if (!/^[6-9]\d{9}$/.test(trimmed)) {
      alert('Please enter a valid 10-digit Indian mobile number.');
      return;
    }

    if (!user) {
      alert('User data not loaded yet. Please try again.');
      return;
    }

    const fullNumber = `91${trimmed}`;
    const referralCode = data?.referralCode || '';

    // Merchant referral link
    const message = encodeURIComponent(
      `Hey! Check out this amazing platform https://bakpoket.com/userSignup/${referralCode}. Join using my referral!`
    );

    window.open(`https://wa.me/${fullNumber}?text=${message}`, '_blank');
  };

  // console.log('Referral Code:', data?.referralCode);

  return (
    <Container>
      <InnerBox>
        <h5>Refer a Friend via WhatsApp</h5>
        <Input
          type="tel"
          placeholder="Enter 10-digit mobile number"
          value={phoneNumber}
          onChange={(e) => setPhoneNumber(e.target.value.replace(/\D/g, '').slice(-10))}
        />
        <Button onClick={handleRefer} disabled={!user || loading}>
          {loading ? 'Loading...' : 'Send Referral'}
        </Button>
      </InnerBox>
    </Container>
  );
};

export default Refaral;

// Styled Components
const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 20px;
`;

const InnerBox = styled.div`
  width: 100%;
  max-width: 400px;
`;

const Input = styled.input`
  width: 100%;
  padding: 12px;
  font-size: 16px;
  margin: 12px 0;
  border: 1px solid #ccc;
  border-radius: 8px;
  @media (max-width: 576px) {
    padding: 7px;
    font-size: 11px;
    margin: 6px 0;
  }
`;

const Button = styled.button`
  width: 100%;
  padding: 12px 20px;
  font-size: 16px;
  background-color: #25d366;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;

  &:hover {
    background-color: #1ebd5a;
  }

  &:disabled {
    background-color: #a6a6a6;
    cursor: not-allowed;
  }

  @media (max-width: 576px) {
    padding: 7px 10px;
    font-size: 10px;
  }
`;


